import MobileSliderPagesWrapper from "../../components/MobileSliderPagesWrapper.jsx";
import MobileSliderPagesHeader from "../../components/MobileSliderPagesHeader.jsx";
import { createStructuredSelector } from "reselect";
import { getLiteTradeAccountMetrics } from "../../../../../modules/LiteTrade/liteTradeSelectors";
import { connect } from "react-redux";
import {
    SlideMobileAccountStateItemStyled,
    SlideMobileAccountStateStyledContainer
} from "./styled/SlideMobileAccountStateStyled";
import amountFormat from "../../../../../utils/amountFormat";
import { useLangContext } from "../../../../../providers/LangProvider/LangProviderContext";
import SlideMobileAccountStatFaq from "./SlideMobileAccountStatFaq";

function SlideMobileAccountStat(props) {
    const { metrics } = props;
    const { getLangPath } = useLangContext();

    const marginLevel = metrics?.margin ? `${amountFormat(metrics.equity / metrics.margin * 100)}%` : '-';
    return <MobileSliderPagesWrapper>
        <MobileSliderPagesHeader>
            <h4 className="mb-0 text-center f16">{getLangPath('lite_version.home.overview')}</h4>
        </MobileSliderPagesHeader>
        <SlideMobileAccountStateStyledContainer>
            <SlideMobileAccountStateItemStyled>
                <span>{getLangPath('menu.balance')}</span>
                <span>{amountFormat(metrics?.balance || 0, 2, '$')}</span>
            </SlideMobileAccountStateItemStyled>
            <SlideMobileAccountStateItemStyled>
                <span>{getLangPath('menu.equity')}</span>
                <span>{amountFormat(metrics?.equity || 0, 2, '$')}</span>
            </SlideMobileAccountStateItemStyled>
            <SlideMobileAccountStateItemStyled>
                <span>{getLangPath('menu.pl')}</span>
                <span>{amountFormat(metrics?.openPL || 0, 2, '$')}</span>
            </SlideMobileAccountStateItemStyled>
            <SlideMobileAccountStateItemStyled>
                <span>{getLangPath('menu.used_margin')}</span>
                <span>{amountFormat(metrics?.margin || 0, 2, '$')}</span>
            </SlideMobileAccountStateItemStyled>
            <SlideMobileAccountStateItemStyled>
                <span>{getLangPath('menu.free_margin')}</span>
                <span>{amountFormat(metrics?.marginFree || 0, 2, '$')}</span>
            </SlideMobileAccountStateItemStyled>
            <SlideMobileAccountStateItemStyled>
                <span>{getLangPath('menu.margin_level')}</span>
                <span>{marginLevel}</span>
            </SlideMobileAccountStateItemStyled>
        </SlideMobileAccountStateStyledContainer>

        <SlideMobileAccountStatFaq className="ms-3 mt-2rem"/>
    </MobileSliderPagesWrapper>
}

const mapStateToProps = createStructuredSelector({
    metrics: getLiteTradeAccountMetrics,
});

export default connect(mapStateToProps)(SlideMobileAccountStat);
